<template>
  <div class="panel-wrapper">
    <div class="panel-header">
      <div>
        <el-select
          placeholder="请选择方案"
          :value="planId"
          size="mini"
          @change="planChange"
        >
          <el-option
            v-for="item in plans"
            :key="item.planId"
            :label="item.planName"
            :value="item.planId"
          >
          </el-option>
        </el-select>
      </div>
      <el-button type="text" @click="exportReports" >下载报告</el-button>
      <el-button type="text" @click="goToProject">返回项目</el-button>
    </div>
    <div class="panel-body">
      <div class="height-area">
        <div style="width:60px">高度</div>
        <div>
          <el-select
            v-model="datasetHeight"
            placeholder="选择高度"
            @change="handleDataHeightChange"
          >
            <el-option
              v-for="(v, i) in heightList"
              :key="i"
              :label="v + 'm'"
              :value="v"
            ></el-option>
          </el-select>
        </div>
      </div>
      <!--div class="btn-area">
        <div
          v-for="(item, index) in btnList"
          :key="index"
          :class="[
            'btn-item',
            {
              'is-active': item.elementCode === elementCode
            }
          ]"
          @click="handleBtnClick(item, index)"
        >
          {{ item.name }}
        </div>
      </div-->
      <!-- <div class="data-area">
        <el-radio
          :value="legendRange"
          label="1"
          @change="handleLeftLegendChange"
          >固定图例</el-radio
        >
        <el-radio
          :value="legendRange"
          label="2"
          @change="handleRightLegendChange"
          >动态图例</el-radio
        >
      </div> -->
      <div
        class="pic-area"
        id="my-node"
        v-if="simpleValues.length > 0 && !loading"
      >
        <el-checkbox
          v-model="isElementChecked"
          label="风速"
          @change="checkboxChange(btnList[0])"
        >
        </el-checkbox>
        <color-simple
          type="horizontal"
          :colors="colors"
          :values="simpleValues"
          :unit="activeUnit"
          width="100%"
        ></color-simple>
        <!-- <img class="img-current" :src="config.tupuUrl" /> -->
      </div>

      <div v-if="turbine" class="tower-info-container">
        <div class="title">风机：{{ turbine ? turbine.turbineNo : '' }}</div>
        <tower-info :turbine="turbine"></tower-info>
      </div>

      <div v-if="tower" class="point-info-container">
        <div class="title">测风塔概况{{ tower ? tower.towerNo : '' }}</div>
        <point-info :info="tower" :datasetHeight="datasetHeight"></point-info>
      </div>
    </div>
  </div>
</template>

<script>
import { FLOW_COLORS } from '@/utils/constants';
import { getToken  } from '@/utils';
import { toFixed } from '../../plan/utils';
import PointInfo from './point-info';

export default {
  components: {
    PointInfo
  },
  props: {
    planId: String,
    cityId: String,
    plans: Array,
    windfarm: Array,
    turbine: Object,
    tower: Object,
    projectItem: Object,
    simple: Array,
    heightList: Array,
  },
  data() {
    return {
      legendRange: '2',
      config: {
        itemName: '',
        elementCode: ''
      },
      colors: FLOW_COLORS,
      activeValues: [],
      activeUnit: 'm/s',
      picName: '',
      elementCode: 'wspd',
      datasetHeight: 100,
      isElementChecked: true,
      // heightList: [100, 150, 200],
      btnList: [
        {
          name: '风速',
          elementCode: 'wspd',
          dyValues: [],
          values: [3, 4, 5, 6, 7, 8, 9, 10],
          unit: 'm/s'
        },
        {
          name: '气温',
          elementCode: 't',
          dyValues: [],
          values: [-10, -5, 0, 5, 10, 15, 20, 25, 30],
          unit: '℃'
        },
        {
          name: '气压',
          elementCode: 'p',
          dyValues: [],
          unit: 'hPa',
          values: []
        },
        {
          name: '风功率',
          elementCode: 'wpd',
          unit: 'W/㎡',
          dyValues: [],
          values: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]
        }
      ]
    };
  },
  watch: {
    cityId() {
      if (!this.cityId) return;
      this.queryUrl();
    }
  },
  mounted() {
  },
  computed: {
    simpleValues: function() {
      return this.activeValues;
    }
  },
  methods: {
    exportReports() {
      const apiKey = getToken();
      window.open(`${process.env.VUE_APP_API_HOST_WINDDATA}/windfarm/stationReport/downReport?apiKey=${apiKey}&projectId=${this.$route.query.projectId}`,'_parent');
      return;
    },
    planChange(value) {
      this.$emit('planChange', value);
    },
    handleDataHeightChange() {
      this.queryUrl();
      this.$emit('heightChange', this.datasetHeight);
    },
    queryUrl() {
      if (!this.elementCode) return;

      this.loading = true;
      this.$postForm('/windfarm/project/plane/getElementsPicPath', {
        data: {
          datasetCode: this.datasetCode || '',
          datasetHeight: this.datasetHeight || '',
          // itemId: this.config.itemId || '',
          elementCode: this.elementCode || '',
          legendRange: this.legendRange || '',
          // geometryInfo: JSON.stringify({
          //   type: 'Polygon',
          //   coordinates: this.windfarm[0].coordinates
          // })
          adcode: this.cityId
        },
        // noKey: this.fromProjectList,
        showError: true
      }).then(res => {
        this.loading = false;
        const { data } = res;
        const { atlas, max, min } = data;
        
        const tupuUrl = process.env.VUE_APP_API_HOST + '/windfarm' + atlas.replace('getElementsPic', 'getElementsPicFor3d');
        // todo更新URL

        const arr = atlas.split('?');
        this.picName = arr[1].split('=')[1];

        this.updateElemenCodeValue(max, min);

        this.activeValues = this.getActiveValues();
        this.activeUnit = this.getActiveUnit();

        this.$emit('updateImg', {
          // id: itemId,
          url: tupuUrl + '&version=' + new Date().valueOf()
          // url: 'https://i-1-lanrentuku.52tup.com/2020/9/9/d00c2628-4e7c-4d34-97af-4efd751d7b7f.png?imageView2/2/w/1024/'
        });
      });
    },
    getActiveUnit() {
      console.log('elementCode',this.elementCode)
      if (!this.elementCode) {
        return '';
      }
      return this.btnList.find(i => i.elementCode === this.elementCode)?.unit;
    },
    getActiveValues() {
      if (!this.elementCode) {
        return [];
      }

      if (this.legendRange == 2) {
        return this.btnList.find(i => i.elementCode === this.elementCode)
          .dyValues;
      }
      if (this.legendRange == 1) {
        return this.btnList.find(i => i.elementCode === this.elementCode)
          .values;
      }
      return [];
    },
    updateElemenCodeValue(max, min) {
      if (this.legendRange == 2 || this.elementCode === 'p') {
        const unit = (max - min) / 10;
        const newArr = new Array(11).fill('');

        const item = this.btnList.find(i => i.elementCode === this.elementCode);

        item.dyValues = newArr.map((i, index) => {
          let fixUnit = 0;
          if (this.elementCode === 'wspd') {
            fixUnit = 1;
          }

          return toFixed(min + unit * index, fixUnit);
        });

        if (this.elementCode === 'p') {
          const item = this.btnList.find(
            i => i.elementCode === this.elementCode
          );
          item.values = newArr.map((i, index) => {
            let fixUnit = 0;
            if (this.elementCode === 'wspd') {
              fixUnit = 1;
            }
            return toFixed(min + unit * index, fixUnit);
          });
        }
      }
    },

    goToProject() {
      let path = 'project-list'; //规划

      const query = {
        projectId: this.projectItem.projectId,
        projectName: this.projectItem.projectName,
      };

      this.$router.push({
        path: `/${path}`,
        query: query,
      });
    },

    handleLeftLegendChange() {
      this.legendRange = '1';
      this.queryUrl();
    },
    handleRightLegendChange() {
      this.legendRange = '2';
      this.queryUrl();
    },
    handleBtnClick(item) {
      if (this.elementCode === item.elementCode) {
        this.$emit('updateImg', null);
        this.elementCode = '';
        return;
      }

      this.elementCode = item.elementCode;

      this.queryUrl();
    },
    checkboxChange() {
      if (this.elementCode === "wspd") {
        this.$emit('clearImg');
        this.elementCode = '';
        return;
      }
      this.elementCode = "wspd";

      this.queryUrl();
    },
  }
};
</script>

<style lang="less" scoped>
.panel-wrapper {
  .tower-detail-point {
    bottom: -27px;
    height: 250px;
    right: 5px;
    top: auto;
    z-index: 1100;
  }
  .panel-header {
    width: 320px;
    position: absolute;
    right: 5px;
    top: 55px;

    display: flex;
    color: @black-color;
    font-size: 12px;
    align-items: center;
    padding: 8px;
    background: rgba(255, 255, 255, 0.9);

    .el-select {
      margin: 0 10px;
    }
  }
  .panel-body {
    background: rgba(255, 255, 255, 0.9);
    width: 360px;
    position: absolute;
    top: 55px;
    left: 5px;
  }
  .btn-area {
    margin: 10px;
    display: flex;
    .btn-item {
      display: inline-block;
      padding: 5px;
      line-height: 20px;
      flex: 1;
      border: 2px solid #a8cae9;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
      margin-bottom: 13px;
      background-color: #d9e6f3;

      &:not(:last-child) {
        margin-right: 5px;
      }

      &.is-active {
        background-color: #0159ac;
        color: #fff;
      }
    }
  }

  .pic-area {
    margin: 0 10px 5px 10px;
    display: flex;
    align-items: center;
    .img-current {
      width: 100%;
    }
  }

  .data-area {
    padding: 10px 0 0 18px;
  }

  .height-area {
    margin: 10px;
    display: flex;
    line-height: 28px;
    color: @black-color;
  }

  .tower-info-container {
    position: fixed;
    bottom: 0;
    height: 220px;
    width: 420px;
    background: #081a29;
    .title {
      height: 43px;
      background: #133C62;
      line-height: 43px;
      color: #fff;
      font-size: 18px;
      padding-left: 30px;
    }
  }

  .point-info-container {
    position: fixed;
    bottom: 0;
    height: 220px;
    width: 420px;
    background: #081a29;
    .title {
      height: 43px;
      background: #133C62;
      line-height: 43px;
      color: #fff;
      font-size: 18px;
      padding-left: 30px;
    }
  }
}
</style>
